/**
 * Mirrors BigDecimal.setScale(2, RoundingMode.HALF_UP).intValue()
 * (truncate toward zero after half-up to 2 decimals).
 */
export function javaIntSize(value) {
    const scaled = Number(Number(value).toFixed(2));
    return scaled < 0 ? Math.ceil(scaled) : Math.floor(scaled);
}

/** Mirrors BigDecimal.setScale(2, RoundingMode.HALF_UP).toPlainString()-like label */
export function javaSizeLabel(value) {
    return Number(value).toFixed(2);
}

/** Mirrors BigDecimal.intValue() for coordinates / points */
export function javaIntCoord(value) {
    const n = Number(value);
    return n < 0 ? Math.ceil(n) : Math.floor(n);
}
